<template>
    <div class="md-mls" :class="theme">
        <hr class="line" />
        <div class="mls-container" v-if="info.mlsOrg">
            <!-- SITE-15435 -->
            <template v-if="info.mlsOrg.id == 128">
                <div class="mls-img img-content">
                    <a
                        :href="info.chimeExternalLink || null"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <site-img
                            dir="height"
                            src="https://www.realtor.ca/images/en-ca/powered_by_realtor.svg"
                            :alt="$t('md-sold-detail.poweredByRealtorca')"
                        ></site-img>
                    </a>
                </div>
            </template>
            <template v-else-if="info.mlsOrg && showlogo">
                <div class="mls-img img-content">
                    <site-img
                        dir="height"
                        :alt="info.mlsOrg.name"
                        :src="
                            isMobileSize
                                ? info.mlsOrg.smallLogo
                                : info.mlsOrg.logo
                        "
                    ></site-img>
                </div>
            </template>
            <div class="text-container">
                <div
                    v-if="info.mlsOrg && info.mlsOrg.copyright"
                    class="mls-copyright"
                >
                    <p v-html="info.mlsOrg.copyright"></p>
                </div>
                <Provided v-if="provided" :theme="provided"></Provided>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';


import Provided from './provided';

export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    data: function() {
        return {};
    },
    props: {
        theme: {
            type: String,
            default: ''
        },
        provided: {
            default: ''
        }
    },
    created() {
        if (this.info.mlsOrg && this.info.mlsOrg.copyright) {
            this.info.mlsOrg.copyright = this.info.mlsOrg.copyright.replace(
                "${.now?string('yyyy')}",
                new Date().getFullYear()
            );
        }
    },
    methods: {},
    computed: {

        ...mapState({
            "info": store => store.listingDetail.info || {}
        }),
        showlogo() {
            if (!this.isMobileSize && this.info.mlsOrg.logo) {
                return true; 
            }
            if (this.isMobileSize && this.info.mlsOrg.smallLogo) {
                return true; 
            }
            return false;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        
    },
    components: { Provided }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-mls {
    clear: both;
    overflow: hidden;
    hr {
        height: 1px;
        border: none;
        border-top: 1px solid #e5e8f1;
    }
    .mls-container {
        &.padding {
            width: calc(100% - 120px);
        }
        .mls-img {
            position: relative;
            height: 40px;
            overflow: hidden;
            margin-bottom: 10px;
            img {
                height: 100%;
            }
        }
        .text-container {
            .mls-copyright {
                font-size: 14px;
                line-height: 20px;
                color: var(--color-label);
            }
        }
        .mls-provided-container .mls-provided {
            margin-top: 10px;
            color: var(--color-label);
        }
    }
    @include media-600 {
        .mls-container {
            &.padding {
                width: 100%;
            }
        }
    }
    @include media-800 {
        .mls-container {
            .text-container {
                .mls-copyright {
                    font-size: 13px;
                }
            }
        }
    }
}
.md-mls.classic {
    hr {
        margin-top: 60px;
    }
    .mls-container {
        margin-top: 55px;
        .mls-img {
            margin-bottom: 10px;
        }
    }
    @include media-600 {
        hr {
            margin-top: 40px;
        }
    }
}
.md-mls.standard {
    hr {
        margin-top: 60px;
    }
    .mls-container {
        margin-top: 55px;
        .mls-img {
            margin-bottom: 18px;
        }
    }
    @include media-600 {
        hr {
            margin-top: 40px;
        }
    }
}
.md-mls.fashion {
    hr {
        margin-top: 60px;
    }
    .mls-container {
        margin-top: 60px;
        .mls-img {
            margin-bottom: 18px;
        }
    }
    @include media-600 {
        hr {
            margin-top: 40px;
        }
    }
}
.md-mls.broker {
    hr {
        display: none;
    }
    .mls-container {
        margin-top: 20px;
        .mls-copyright p {
            line-height: 1.67;
            color: #a8a8a8;
        }
    }
}
</style>
